import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { BrgButton, ButtonVariant, CommonInput, INPUT_TYPES } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useModal } from 'core';
import { useDispatch, useSelector } from 'react-redux';
import { useProfile } from '@brg/auth';
import { IconCloseMob } from 'shared/modals/SelectGeoLocationTagsModal/SelectGeoLocationTagsModal';
import {
  CloseButton,
  FoldersColumnContainer,
  ModalActions,
  ModalBody,
  ModalDescription,
  ModalFilledButton,
  ModalHeaderRow,
  ModalHollowButton,
  ModalTitle,
} from './styles';
import useQueryState from 'shared/hooks/useQueryState';
import { CompetitionAdminActions, CompetitionAdminSelector } from 'shared/reducers/CompetitionAdminSlice';
import { useGetCompetitionNavigateTabs } from 'shared/components/navigationSystem/useGetCompetitionNavigateTabs';
import { useGetCompetitionsAdminPageActions } from '_competition/pages/CompetitionsAdmin/hooks/useGetCompetitionsAdminPageActions';
import { FolderT } from 'shared/pages/designer/components/tabs/const';
import { TLang } from '@brg/api';
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import setTextByLang from 'shared/helpers/setTextByLang';
import { tryParseJson } from 'shared/helpers/tryParseJson';

type MoveCompetitionsModalProps = {
//   mode: 'join' | 'change';
//   targetTeamId: string;
//   targetTeamName: string;
//   currentClubName?: string;
folder: FolderT,
onConfirm: (folderId: string, competitionsIds: string[]) => void
};

export const CompetitionEditFolderModal: FC<MoveCompetitionsModalProps> = ({
//   mode,
//   targetTeamId,
//   targetTeamName,
//   currentClubName,
folder,
onConfirm
}) => {
  const { t } = useTranslation();
  const modal = useModal();
  const dispatch = useDispatch();
  const [name, setName] = useState<TLang[]>(createDefaultLangObject(''));

  const { onUpdateFolder, onDeleteFolder } = useGetCompetitionsAdminPageActions();


  useEffect(() => {
    if (tryParseJson(folder.name)) {
      setName(JSON.parse(folder.name))
    } else {
      setName(createDefaultLangObject(folder.name));
    }
  } , [folder.name])

  const handleClose = useCallback(() => {
    modal.hide();
    dispatch(CompetitionAdminActions.setIsCreated({ isCreated: false, createdType: '' }));
  }, [modal]);

  const handleConfirm = () => {
    onUpdateFolder({ ...folder, name: JSON.stringify(name) }, 'update');
    handleClose();
  };

  const handleDelete = () => {
    onDeleteFolder(folder.id ?? '')
    handleClose();
  }

  return (
    <ModalBody>
      <ModalHeaderRow>
        <ModalTitle>{'Настройка папки'}</ModalTitle>
        <CloseButton type="button" onClick={handleClose} aria-label={t('close')}>
          <IconCloseMob />
        </CloseButton>
      </ModalHeaderRow>
      <CommonInput 
        type={INPUT_TYPES.text}
        value={name ?? ''}
        useLangSwitcher
        label={'Название папки'}
        orientation="column"
        onChange={(ev: any, lang?: string) => setName(setTextByLang(name, lang ?? 'ru', ev.target.value))}
      />
      <ModalActions>
      <ModalHollowButton
          variant={ButtonVariant.Hollow}
          fullWidth
          onClick={handleClose}
        >
          {'Отмена'}
        </ModalHollowButton>
        <ModalFilledButton
          variant={ButtonVariant.Filled}
          fullWidth
          onClick={handleConfirm}
        >
          {'Сохранить'}
        </ModalFilledButton>
        <ModalFilledButton
          variant={ButtonVariant.Filled}
          fullWidth
          onClick={handleDelete}
          red
        >
          {'Удалить'}
        </ModalFilledButton>
      </ModalActions>
    </ModalBody>
  );
};

export default CompetitionEditFolderModal;
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { BrgButton, ButtonVariant, CommonInput, INPUT_TYPES } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useModal } from 'core';
import { useDispatch, useSelector } from 'react-redux';
import { useProfile } from '@brg/auth';
import { IconCloseMob } from 'shared/modals/SelectGeoLocationTagsModal/SelectGeoLocationTagsModal';
import {
  CloseButton,
  FoldersColumnContainer,
  ModalActions,
  ModalBody,
  ModalDescription,
  ModalFilledButton,
  ModalHeaderRow,
  ModalHollowButton,
  ModalTitle,
} from './styles';
import useQueryState from 'shared/hooks/useQueryState';
import { CompetitionAdminActions, CompetitionAdminSelector } from 'shared/reducers/CompetitionAdminSlice';
import { useGetCompetitionNavigateTabs } from 'shared/components/navigationSystem/useGetCompetitionNavigateTabs';
import { useGetCompetitionsAdminPageActions } from '_competition/pages/CompetitionsAdmin/hooks/useGetCompetitionsAdminPageActions';
import { FolderT } from 'shared/pages/designer/components/tabs/const';
import { TLang } from '@brg/api';
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import setTextByLang from 'shared/helpers/setTextByLang';
import { tryParseJson } from 'shared/helpers/tryParseJson';

type MoveCompetitionsModalProps = {
//   mode: 'join' | 'change';
//   targetTeamId: string;
//   targetTeamName: string;
//   currentClubName?: string;
folder: FolderT,
onConfirm: (folderId: string, competitionsIds: string[]) => void
};

export const CompetitionEditFolderModal: FC<MoveCompetitionsModalProps> = ({
//   mode,
//   targetTeamId,
//   targetTeamName,
//   currentClubName,
folder,
onConfirm
}) => {
  const { t } = useTranslation();
  const modal = useModal();
  const dispatch = useDispatch();
  const [name, setName] = useState<TLang[]>(createDefaultLangObject(''));

  const { onUpdateFolder, onDeleteFolder } = useGetCompetitionsAdminPageActions();


  useEffect(() => {
    if (tryParseJson(folder.name)) {
      setName(JSON.parse(folder.name))
    } else {
      setName(createDefaultLangObject(folder.name));
    }
  } , [folder.name])

  const handleClose = useCallback(() => {
    modal.hide();
    dispatch(CompetitionAdminActions.setIsCreated({ isCreated: false, createdType: '' }));
  }, [modal]);

  const handleConfirm = () => {
    onUpdateFolder({ ...folder, name: JSON.stringify(name) }, 'update');
    handleClose();
  };

  const handleDelete = () => {
    onDeleteFolder(folder.id ?? '')
    handleClose();
  }

  return (
    <ModalBody>
      <ModalHeaderRow>
        <ModalTitle>{'Настройка папки'}</ModalTitle>
        <CloseButton type="button" onClick={handleClose} aria-label={t('close')}>
          <IconCloseMob />
        </CloseButton>
      </ModalHeaderRow>
      <CommonInput 
        type={INPUT_TYPES.text}
        value={name ?? ''}
        useLangSwitcher
        label={'Название папки'}
        orientation="column"
        onChange={(ev: any, lang?: string) => setName(setTextByLang(name, lang ?? 'ru', ev.target.value))}
      />
      <ModalActions>
      <ModalHollowButton
          variant={ButtonVariant.Hollow}
          fullWidth
          onClick={handleClose}
        >
          {'Отмена'}
        </ModalHollowButton>
        <ModalFilledButton
          variant={ButtonVariant.Filled}
          fullWidth
          onClick={handleConfirm}
        >
          {'Сохранить'}
        </ModalFilledButton>
        <ModalFilledButton
          variant={ButtonVariant.Filled}
          fullWidth
          onClick={handleDelete}
          red
        >
          {'Удалить'}
        </ModalFilledButton>
      </ModalActions>
    </ModalBody>
  );
};

export default CompetitionEditFolderModal;
